import factory from './icon';
import UncheckedSvg from './glyphs/radio-button.svg';
import CheckedSvg from './glyphs/radio-button-checked.svg';

export const Unchecked = factory(UncheckedSvg);
export const Checked = factory(CheckedSvg);
